import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { nftFaqUrl } from 'dibs-crypto-utils/exports/constants.ts';
import { Link } from 'dibs-elements/exports/Link.tsx';

export const NftFaqLink: FC = () => {
    return (
        <Link href={nftFaqUrl} dataTn="nft-faq-link" key="nft-faq-link">
            <FormattedMessage
                id="nft.nftFaqLink"
                defaultMessage="Learn More about NFTs on 1stDibs"
            />
        </Link>
    );
};
